import { SERVICE_NAME } from "@/config/serviceNames";
import { EntityType, Module } from "@/constants";
import { requests } from ".";
import store from "@/store";

const ResellingService = {
  getSubscriptionsForLocation: (locationId: string) =>
    requests(SERVICE_NAME.RESELLING_API).get(`subscription/location/${locationId}`),

  cancelSubscriptionForLocation: (locationId: string, subscriptionId: string) =>
    requests(SERVICE_NAME.RESELLING_API).delete(
      `subscription/location/${locationId}/${subscriptionId}`
    ),

  convertSubscriptionFromLPtoCDP: (locationId: string, subscriptionId: string, reason: string) =>
    requests(SERVICE_NAME.RESELLING_API)
      .log({
        module: Module.RESELLING,
        entityType: EntityType.LOCATION,
        entityId: locationId,
        documentId: subscriptionId,
      })
      .post(`support/convert-location-purchase-to-cdp`, {
        locationId,
        subscriptionId,
        comment: reason,
        email: store.state.auth.user?.email,
      }),

  getSubscriptionsForCompany: (companyId: string) =>
    requests(SERVICE_NAME.RESELLING_API)
      .log({
        module: Module.RESELLING,
        entityType: EntityType.COMPANY,
        entityId: companyId,
      })
      .get(`subscription/company/${companyId}`),

  cancelSubscriptionForCompany: (companyId: string, subscriptionId: string) =>
    requests(SERVICE_NAME.RESELLING_API)
      .log({
        module: Module.RESELLING,
        entityType: EntityType.COMPANY,
        entityId: companyId,
      })
      .delete(`subscription/company/${companyId}/${subscriptionId}`),

  getUnsubscribedLocations: (subscriptionId: string) =>
    requests(SERVICE_NAME.RESELLING_API)
      .log({
        module: Module.RESELLING,
        entityType: EntityType.COMPANY,
        entityId: "companyId",
      })
      .get(`support/unsubscribed-beneficiaries/${subscriptionId}`),

  resubscribeLocations: (subscriptionId: string, beneficiaryIds: string[]) =>
    requests(SERVICE_NAME.RESELLING_API)
      .log({
        module: Module.RESELLING,
        entityType: EntityType.COMPANY,
        entityId: "companyId",
      })
      .post(`support/recover-beneficiaries/${subscriptionId}`, {
        beneficiaryIds,
        email: store.state.auth.user?.email,
      }),
};

export default ResellingService;
